import { useCallback, useEffect, useState } from "react";
import api from "../api";
import { useCompanyApi } from "./useCompanyApi";

const useLoadWidget = ({ test, onSendMessage }) => {
  const chatbotUuid = localStorage.getItem("chatbot_uuid");

  const [iframeLoaded, setIframeLoaded] = useState(false);

  const [showReviseModal, setShowReviseModal] = useState(false);

  const [reviseAnswerData, setReviseAnswerData] = useState({
    question: "",
    agent_response: "",
  });

  const { company, fetchCompany } = useCompanyApi();

  const [chatSettings, setChatSettings] = useState({
    companyName: "",
    chatColor: "#7856d2",
    buttonColor: "#7856d2",
    companyImageUrl: "",
    isDataLoad: false,
  });

  useEffect(() => {
    fetchCompany();
    setIframeData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatbotUuid]);

  useEffect(() => {
    if (company) {
      setChatSettings(prev => ({
        ...prev,
        companyName: company.name,
        companyImageUrl: company.picture_url,
      }));
    }
  }, [company]);

  const onLoad = () => setIframeLoaded(true);

  const setIframeData = useCallback(async () => {
    if (!chatSettings.isDataLoad) {
      const response = await api.get(`/api/chatbot/${chatbotUuid}`);
      const chatbot = response.data;
      setChatSettings(prev => ({
        ...prev,
        buttonColor: `#${chatbot.button_color}`,
        chatColor: `#${chatbot.chat_color}`,
        isDataLoad: true,
      }));
    }
  }, [chatbotUuid, chatSettings.isDataLoad]);

  const postIframeMessage = resetConversation => {
    const iframe = document.getElementById("support-magic-widget-iframe");
    if (iframe) {
      iframe.contentWindow.postMessage(
        {
          type: "SET_CUSTOM_OPTIONS",
          resetConversation: resetConversation,
          url: window.location.href,
          tenantId: chatbotUuid,
          secondaryColor: chatSettings.buttonColor,
          fontColor: chatSettings.chatColor,
          companyName: chatSettings.companyName,
          companyLogo: chatSettings.companyImageUrl,
          accessToken: sessionStorage.getItem("supabase_jwt"),
          test,
        },
        "*"
      );
    }
  };

  useEffect(() => {
    if (chatSettings.isDataLoad && chatbotUuid && iframeLoaded) {
      const firstLoad = !localStorage.getItem("reset_conversation_done");

      postIframeMessage(firstLoad);

      if (firstLoad) {
        localStorage.setItem("reset_conversation_done", "true");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatbotUuid, chatSettings, setIframeData, iframeLoaded]);

  const onResetConversation = () => {
    postIframeMessage(true);
  };

  useEffect(() => {
    function onIframeMessage(event) {
      const { type, messages, idx } = event.data;

      if (type === "SEND_MESSAGE" && typeof onSendMessage === "function") {
        onSendMessage(event.data);
      }

      if (type === "REVISE_ANSWER_EVENT") {
        let questionMessage = messages[idx + 1];

        setReviseAnswerData({
          agent_response: messages[idx]?.content,
          question: questionMessage?.content,
        });

        setShowReviseModal(true);
      }
    }

    window.addEventListener("message", onIframeMessage);
    return () => {
      window.removeEventListener("message", onIframeMessage);
    };
  }, []);

  return {
    reviseAnswerData,
    showReviseModal,
    setShowReviseModal,
    onResetConversation,
    onLoad,
  };
};

export default useLoadWidget;
